import { Flex, Stack } from "../mantine-passthroughs/index.js";
import { Anchor } from "../anchor/Anchor.js";
import { HorizontalDivider } from "../divider/variants/HorizontalDivider.js";
import { VerticalDivider } from "../divider/variants/VerticalDivider.js";
import { Body1 } from "../typography/Body1.js";
import { Body2 } from "../typography/Body2.js";
import { Subtitle1 } from "../typography/Subtitle1.js";
import { Subtitle2 } from "../typography/Subtitle2.js";
import { Subtitle3 } from "../typography/Subtitle3.js";
import { Caption } from "../typography/Caption.js";
import { jsx } from "react/jsx-runtime";

//#region src/components/rich-text/Shared.tsx
const coreComponents = {
	b: /* @__PURE__ */ jsx("strong", {}),
	br: /* @__PURE__ */ jsx("br", {}),
	sup: /* @__PURE__ */ jsx("sup", {}),
	sub: /* @__PURE__ */ jsx("sub", {}),
	a: /* @__PURE__ */ jsx(Anchor, { target: "_blank" }),
	body1: /* @__PURE__ */ jsx(Body1, {}),
	body2: /* @__PURE__ */ jsx(Body2, {}),
	caption: /* @__PURE__ */ jsx(Caption, {}),
	hr: /* @__PURE__ */ jsx(HorizontalDivider, {}),
	vr: /* @__PURE__ */ jsx(VerticalDivider, {}),
	flex: /* @__PURE__ */ jsx(Flex, {}),
	stack: /* @__PURE__ */ jsx(Stack, {}),
	subtitle1: /* @__PURE__ */ jsx(Subtitle1, {}),
	subtitle2: /* @__PURE__ */ jsx(Subtitle2, {}),
	subtitle3: /* @__PURE__ */ jsx(Subtitle3, {})
};

//#endregion
export { coreComponents };